/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import { Heart } from "lucide-react";
import { useFavorites } from "../hooks/use-favorites";
import { cn } from "@/lib/util/utils";
import { useState } from "react";

export const FavoriteButton = ({
  productId,
  className,
}: {
  productId: string;
  className?: string;
}) => {
  const { isFavorite, addFavorite, removeFavorite, favorites, isLoading } =
    useFavorites();
  const [isProcessing, setIsProcessing] = useState(false);

  const isFav = isFavorite(productId);

  const toggle = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isProcessing || isLoading) return;

    setIsProcessing(true);
    try {
      if (isFav) {
        // Find favorite ID
        const fav = favorites?.find((f: any) => f.product_id === productId);
        if (fav) {
          await removeFavorite(fav.id);
        }
      } else {
        await addFavorite(productId);
      }
    } catch (err: any) {
      // A 401 never lands here any more: addFavorite/removeFavorite bounce to
      // login from the server action itself. Message sniffing could not have
      // worked regardless — in production Next redacts the message.
      console.error("❌ Error al actualizar favoritos:", err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={isProcessing || isLoading}
      className={cn(
        "rounded-full p-2 transition-all hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      aria-label={isFav ? "Remover de favoritos" : "Añadir a favoritos"}
    >
      <Heart
        className={cn(
          "h-6 w-6 transition-all",
          isProcessing && "animate-pulse",
          isFav ? "fill-orange-main text-orange-main" : "text-gray-400"
        )}
      />
    </button>
  );
};
